"use client";

import { useEffect } from "react";
import { useSearchParams, useRouter } from "next/navigation";
import { toast } from "sonner";

export function EmailVerificationToast() {
  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    const verified = searchParams.get("email_verified");
    const error = searchParams.get("email_error");

    if (verified === "true") {
      toast.success("Email vinculado correctamente a tu cuenta.");
    } else if (error === "expired") {
      toast.error("El enlace ha expirado. Solicita uno nuevo.");
    } else if (error === "invalid") {
      toast.error("El enlace de verificación no es válido.");
    } else if (error === "failed") {
      toast.error("Error al vincular el email. Intenta de nuevo.");
    } else {
      return; // No relevant params — don't touch the URL
    }

    // Clean up URL params
    const url = new URL(window.location.href);
    url.searchParams.delete("email_verified");
    url.searchParams.delete("email_error");
    router.replace(url.pathname + url.search, { scroll: false });
  }, [searchParams, router]);

  return null;
}
